var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._t("title",[_c('div',{staticClass:"header-title"},[_vm._v("이슈")])]),(_vm.data)?_c('issue-card-legacy',{key:_vm.data.objectId,attrs:{"data":_vm.data,"default-open":true},on:{"change":_vm.load}}):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }